var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCinematicBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_848",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6L12.5 14H18.5L14.5 6H18.5L22.5 14H28.5L24.5 6H28.5L32.5 14H38.5L34.5 6H40.5C41.6 6 42.5417 6.39167 43.325 7.175C44.1083 7.95833 44.5 8.9 44.5 10V38C44.5 39.1 44.1083 40.0417 43.325 40.825C42.5417 41.6083 41.6 42 40.5 42H8.5C7.4 42 6.45833 41.6083 5.675 40.825C4.89167 40.0417 4.5 39.1 4.5 38V10C4.5 8.9 4.89167 7.95833 5.675 7.175C6.45833 6.39167 7.4 6 8.5 6ZM8.5 18V38H40.5V18H8.5ZM16.5 36H32.5V34.9C32.5 33.4333 31.7667 32.25 30.3 31.35C28.8333 30.45 26.9 30 24.5 30C22.1 30 20.1667 30.45 18.7 31.35C17.2333 32.25 16.5 33.4333 16.5 34.9V36ZM24.5 28C25.6 28 26.5417 27.6083 27.325 26.825C28.1083 26.0417 28.5 25.1 28.5 24C28.5 22.9 28.1083 21.9583 27.325 21.175C26.5417 20.3917 25.6 20 24.5 20C23.4 20 22.4583 20.3917 21.675 21.175C20.8917 21.9583 20.5 22.9 20.5 24C20.5 25.1 20.8917 26.0417 21.675 26.825C22.4583 27.6083 23.4 28 24.5 28Z",
    fill: "#f05d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinematicBlur);
export default __webpack_public_path__ + "static/media/cinematic_blur.1959ad8dca4d0580301aa698819f4b1e.svg";
export { ForwardRef as ReactComponent };